// src/Hooks/useProductRequest.ts

import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { productService } from "../Api/services/userProduct";
import { GetRequestsRenseponse, Product } from "../Types/ProductManagement";
import api from "../Api/axios";
import { ENDPOINTS } from "../Api/endpoints";

export const useProductRequest = () => {
  const [request, setRequest] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleError = (err: unknown, defaultMessage: string) => {
    if (err instanceof AxiosError) {
      const errorResponse = err.response?.data as {
        message?: string;
        errors?: {
          issues?: Array<{
            code: string;
            expected: string;
            received: string;
            path: string[];
            message: string;
          }>;
          name?: string;
        };
        statusCode?: number;
      };

      if (
        errorResponse?.errors?.name === "ZodError" &&
        errorResponse.errors.issues
      ) {
        const zodErrorMessage = errorResponse.errors.issues
          .map(
            (issue) => `Field ${issue.path.join(".")} error: ${issue.message}`
          )
          .join(", ");

        setError(`Validation Error: ${zodErrorMessage}`);
      } else {
        setError(errorResponse?.message || err.message || defaultMessage);
      }
    } else {
      setError(defaultMessage);
    }
  };

  const fetchRequests = async (q: string | null) => {
    setLoading(true);
    try {
      var endpoint = `${ENDPOINTS.PRODUCT_REQUESTS}/paginated?page=1&limit=100&query=`;
      if (q) {
        endpoint = endpoint + q;
      }
      const response = await api.get<GetRequestsRenseponse>(endpoint);
      setRequest(response.data.data);
      setError(null);
    } catch (err) {
      handleError(err, "Failed to fetch clients");
    } finally {
      setLoading(false);
      return error;
    }
  };

  const updateRequestStatus = async (
    status: string,
    id: string,
    reason?: string
  ) => {
    setLoading(true);
    try {
      await productService.updateProductRequestStatus(status, id, reason);
      await fetchRequests(null);
      setError(null);
    } catch (err) {
      handleError(err, "Failed to update request status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests(null);
  }, []);

  return {
    request,
    loading,
    error,
    updateRequestStatus,
    fetchRequests,
  };
};
